import { memoizedGroupBySelector } from '@travelnest/entities';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { IBookingsByOwnerIdParams } from '../../../api/bookings';
import { actions as entityActions } from '../../../data/store';
import { getBookingsByOwnerId } from '../../../entities/bookings/actions';
import { IThunkDispatch } from '../../../store/middleware';
import { IState } from '../../../store/reducer';
import { useDataLoad } from '../../../view/helpers/hooks';
import { OwnerBookingsListComponent } from './OwnerBookingsList';

type EventStatus = 'booked' | 'cancelled' | 'failed';
type TimePeriod = 'past' | 'present' | 'future';
type SortDirection = 'ascending' | 'descending';

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	getBookings: (ownerId: string, params?: IBookingsByOwnerIdParams) => dispatch(getBookingsByOwnerId(ownerId, params)).catch((e: any) => e),
	getProperties: (id: string) => dispatch(entityActions.property.getByOwnerId(id)).catch((e: any) => e)
});

const mapStateToProps = (customerId: string) => (state: IState) => {
	const customerProperties = memoizedGroupBySelector('owner_id', state.data.properties.byId)[customerId] || [];
	return {
		bookings: state.entities.bookings.byOwnerId[customerId],
		properties: customerProperties,
		loading: state.views.bookings.loadingBookings,
		customerId
	};
};

export const OwnerBookingsList = () => {
	const params = useParams();
	const customerId = params.id || '';
	const props = {
		...useSelector(mapStateToProps(customerId)),
		...mapDispatchToProps(useDispatch())
	};

	const [state, setState] = React.useState({
		page_number: 1,
		page_size: 25,
		sort_direction: 'ascending' as SortDirection,
		time_period: ['present', 'future'] as TimePeriod[],
		event_status: ['booked'] as EventStatus[]
	});

	const bookingsLoading = useDataLoad(true, () => props.getBookings(props.customerId, state));
	const propertiesLoading = useDataLoad(!props.properties || !props.properties.length, () => props.getProperties(props.customerId));

	const loading = bookingsLoading || propertiesLoading;

	return <OwnerBookingsListComponent
		bookings={props.bookings}
		properties={props.properties}
		loading={loading}
		onUpdateQueryParams={(updatedValues: Partial<IBookingsByOwnerIdParams>) => {
			const nextState = { ...state, ...updatedValues };
			setState(nextState);
			props.getBookings(props.customerId, nextState);
		}}
		currentQueryParams={state}
	/>;
};
